import React,{useState} from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Select from 'react-select'
import Nav from "react-bootstrap/Nav";
import { FiEdit2 } from 'react-icons/fi';
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
// import './EditVehicleDrawer.css'
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector } from "react-redux";
import { updateVehicle } from "../../redux/AdminReducer";
import { updateDriver } from "../../redux/AdminReducer";

import { useDispatch } from "react-redux";

import Swal from "sweetalert2";
const EditDriverDrawer = (props) => {
  const dispatch=useDispatch();
  const vehicleData=useSelector((state)=>state?.AdminReducer?.allVehiclesData);
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );

  console.log("props?.data?.type",props?.data)
  const [vehicle,setVehicle]=useState({
    name:props?.data?.name,
    email:props?.data?.email,
    phone:props?.data?.phone,
    address:props?.data?.address,
    password:'',
    type:props?.data?.type,
     

  });
  const options = [
    { value: 'Mercedes E', label: 'Mercedes E' },
    { value: 'Mercedes V', label: 'Mercedes V' },
    { value: 'Mercedes S', label: 'Mercedes S' }
  ]
  const [imageVehicle, setImageVehicle] = useState();
  const handleChange=(e)=>{

    const{name,value}=e.target;

    console.log("e...............",e)

    setVehicle({
      ...vehicle,[name]:value
    })

  }
  const availabilityChange=(e)=>{

    

    console.log("e...............",e)

    setVehicle({
      ...vehicle,availability:!vehicle.availability
    })

  }


  const handleImage=(e)=>{
    const selected1 = e.target.files[0];

    setImageVehicle(selected1);

  }

  console.log("props?.data?._id",props?.data?._id)

  const addBtnClicked=async()=>{

    const data = new FormData();
    data.append("name", vehicle.name);
    data.append("email", vehicle.email);
    data.append("phone", vehicle.phone);
    data.append("address", vehicle.address);
    data.append("type", vehicle.type);
  
   let id=props?.data?._id;
   const response=await dispatch(updateDriver({id,vehicle,driversData}))

console.log("response",response?.payload?.message)

    
  }
  const handleChangeType=(e)=>{
    console.log("handleChangeTypee",e.value)

    setVehicle({...vehicle,type:e.value})

  }
  const defaultValue = { value:vehicle.type, label:vehicle.type }; // set the second option (Banana) as the default value

  return (
    <>
        {[false].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="mb-3">
          <Container fluid>
            {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}

            <Navbar.Toggle
aria-controls={`offcanvasNavbar-expand-${expand}`}
className="btnEditVehicle"
>
<FiEdit2/>
</Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              className="addVehicleDrawer"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Edit Driver
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mainAddVehicleDrawerFields">
                
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Name :</div>
                    <input
                      placeholder="Please Enter Name"
                      className="inputFieldAddVeh"
                      name="name"
                      value={vehicle.name}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Email :</div>
                    <input
                      placeholder="Please Enter Company Name"
                      className="inputFieldAddVeh"
                      name="email"
                      value={vehicle.email}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Phone Number :</div>
                    <input
                      placeholder="Please Enter Phone Number"
                      className="inputFieldAddVeh"
                      name="phone"
                      value={vehicle.phone}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Address :</div>
                    <input
                      placeholder="Please Enter Address"
                      className="inputFieldAddVeh"
                      name="address"
                      value={vehicle.address}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Vehicle Type:</div>
                    <Select options={options} 
                      className="inputFieldAddVeh inputFieldAddVeh1"
                      name="type"
                      defaultValue={defaultValue }
                      onChange={(e)=>handleChangeType(e)}
                    
                    />

                  </div>

                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Password :</div>
                    <input
                      placeholder="Please Enter  Password"
                      className="inputFieldAddVeh"
                      name="password"
                      // value={vehicle.password}
                      type="password"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
               
                  {/* <div className="topCatagoryField topCatagoryFieldCheck">
                    <div className="catagoryTxtAddVeh">Availability :</div>
                    <label class="switch1">
                      <input type="checkbox" 
                      
                      name="availability"
                      onChange={(e)=>availabilityChange(e)}
                      />
                      <span class="slider1 round1"></span>
                    </label>
                  </div> */}
                  <div className="topCatagoryField topCatagoryFieldCheck">
                   
                  <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
             <button className="cnclBtn">
                        Cancel
                    </button>
            </Navbar.Toggle>
               
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
                    
                    <button className="addBtn" onClick={addBtnClicked}>
                        Update
                        </button>
                        </Navbar.Toggle>
                  </div>
                </div>
                
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default EditDriverDrawer;







